export default __webpack_public_path__ + "static/media/c8.01540f00.PNG";